import { ApiResourceBaseClass as i } from "./baseApiCalls.js";
const a = "reviews";
class c extends i {
  /**
   * Generates fake reviews based on the provided data.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/reviews/generate-fake`
   *
   * @param {FakeReviewsGenerationData} fakeReviews - The data used to generate fake reviews.
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response of the fake review generation.
   */
  generateFakeReviews = async (t) => {
    const { data: e } = await this.post(
      `${a}/generate-fake`,
      t
    );
    return e;
  };
  /**
   * Gets review statistics
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/stats`
   *
   * @param {ReviewQueryParams} queryParams
   */
  async getReviewStats(t) {
    const { data: e } = await this.get(`${a}/stats`, t);
    return e;
  }
  /**
   * Gets a single review
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/:id`
   *
   * @param {number} reviewId
   */
  async getReview(t) {
    const { data: e } = await this.get(`${a}/${t}`);
    return e;
  }
  /**
   * Gets a list of reviews
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews`
   *
   * @param {ReviewQueryParams & CursorPaginationParams} queryParams
   */
  async searchReviews(t) {
    const { data: e } = await this.get(`${a}`, {
      ...t,
      ordering: "-update_date"
    });
    return e;
  }
  /**
   * Updates a review
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/reviews/:id`
   *
   * @param {UpdateReviewParams} params
   */
  async updateReview({ id: t, ...e }) {
    const { data: s } = await this.put(`${a}/${t}`, e);
    return s;
  }
  /**
   * Downloads reviews
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/download`
   *
   * @param {ReviewQueryParams & { email: string }} queryParams
   */
  async downloadReviews(t) {
    const { data: e } = await this.get(`${a}/download`, {
      ...t,
      ordering: "-update_date"
    });
    return e;
  }
  /**
   * Gets a list of reply templates
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/templates/search`
   *
   * @param {ReplyTemplateSearchParams} queryParams
   */
  async searchTemplates(t) {
    const { data: e } = await this.get(
      `${a}/templates/search`,
      t
    );
    return e;
  }
  /**
   * Saves a reply template
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/reviews/templates`
   *
   * @param {SaveReplyTemplatePayload} queryParams
   */
  async saveTemplate(t) {
    const { data: e } = await this.post(`${a}/template`, t);
    return e;
  }
  /**
   * Deletes a reply template
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/reviews/templates/:id`
   *
   * @param {string} templateId
   */
  async deleteReplyTemplate(t) {
    const { data: e } = await this.delete(
      `${a}/template/${t}`
    );
    return e;
  }
  /**
   * Gets the list of available reply template placeholders
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/templates/placeholders`
   *
   */
  async getTemplatePlaceholders() {
    const { data: t } = await this.get(
      `${a}/templates/placeholders`
    );
    return t;
  }
  /**
   * Gets the list of available reply template languages
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/templates/languages`
   *
   * @param {LiteralRating} rating
   */
  async getTemplateLanguages(t) {
    const { data: e } = await this.get(
      `${a}/templates/languages`,
      t ? { [t]: !0 } : {}
    );
    return e;
  }
  /**
   * Gets whether the reply template is used on any auto reply settings
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/templates/:id/has_auto_reply_settings`
   *
   * @param {string} templateId
   */
  async getTemplateHasAutoReplySettings(t) {
    const { data: e } = await this.get(
      `${a}/templates/${t}/has_auto_reply_settings`
    );
    return e;
  }
  /**
   * Downloads the list of reply templates
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/templates/download`
   *
   * @param {string} email
   */
  async downloadTemplates(t) {
    const { data: e } = await this.get(`${a}/templates/download`, {
      email: t
    });
    return e;
  }
  /**
   * Uploads a list of reply templates
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/reviews/templates/upload`
   *
   * @param {Blob} file
   * @param {string} email
   */
  async uploadTemplates(t, e) {
    const s = new FormData();
    t && s.append("file", t), e && s.append("email", e);
    const { data: n } = await this.post(
      `${a}/templates/upload`,
      s
    );
    return n;
  }
  /**
   * @deprecated
   * Gets user permissions on reviews
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/permissions`
   */
  async getPermissions() {
    const { data: t } = await this.get(`${a}/permissions`);
    return t;
  }
  /**
   * Gets a reply suggestion
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/reviews/fetch-suggestion/:reviewId/:index`
   *
   * @param {number} reviewId
   * @param {index} index
   */
  async getReplySuggestion(t, e) {
    const { data: s } = await this.get(
      `${a}/fetch-suggestion/${t}/${e}`
    );
    return s;
  }
  /**
   * Reports a reply suggestion
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/reviews/report-suggestion`
   *
   * @param {number} suggestionId
   */
  async reportSuggestion(t) {
    const { data: e } = await this.post(`${a}/report-suggestion`, {
      suggestion_id: t
    });
    return e;
  }
}
export {
  c as Review
};
